"use client";

import { useActionState } from "react";
import type { LoginState } from "@/app/actions/auth";
import { Brand } from "@/components/shell/brand";
import { Button } from "@/components/ui/button";
import { Callout } from "@/components/ui/callout";
import { Card } from "@/components/ui/card";
import { Field, Input } from "@/components/ui/field";

interface LoginFormProps {
  title: string;
  subtitle?: string;
  action: (state: LoginState, formData: FormData) => Promise<LoginState>;
  expired?: boolean;
}

export function LoginForm({ title, subtitle, action, expired }: LoginFormProps) {
  const [state, formAction, pending] = useActionState(action, undefined);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 py-10">
      <Brand />
      <Card className="w-full max-w-sm">
        <form action={formAction} className="flex flex-col gap-4 p-6">
          <div>
            <h1 className="text-xl font-medium tracking-tight">{title}</h1>
            {subtitle && <p className="mt-0.5 text-[13px] text-ink-muted">{subtitle}</p>}
          </div>

          {expired && !state && (
            <Callout tone="warning">Tu sesión terminó. Vuelve a iniciar sesión.</Callout>
          )}
          {state?.error && <Callout tone="danger">{state.error}</Callout>}

          <Field label="Usuario" error={state?.fieldErrors?.username}>
            <Input
              name="username"
              autoComplete="username"
              maxLength={64}
              defaultValue={state?.username}
              aria-invalid={!!state?.fieldErrors?.username}
            />
          </Field>

          <Field label="Contraseña" error={state?.fieldErrors?.password}>
            <Input
              name="password"
              type="password"
              autoComplete="current-password"
              maxLength={128}
              aria-invalid={!!state?.fieldErrors?.password}
            />
          </Field>

          <Button type="submit" disabled={pending} className="mt-1">
            {pending ? "Entrando…" : "Iniciar sesión"}
          </Button>
        </form>
      </Card>
    </main>
  );
}
